import { ThemeEnum } from '~/enums/Region'
import { H3Event } from 'h3'
import { getCurrentTheme } from '~/utils/locale/getCurrentTheme'
import type { RuntimeConfig } from 'nuxt/schema'

export default (event?: H3Event, config?: RuntimeConfig) => {
  const theme = getCurrentTheme(event, config)

  const isShipzee = theme === ThemeEnum.SHIPZEE
  const isWhitelabel = theme === ThemeEnum.WHITELABEL
  const isPerkujav = theme === ThemeEnum.PERKUJAV
  const isNoriuLive = theme === ThemeEnum.NORIULIVE
  const isTarpininke = theme === ThemeEnum.TARPININKE
  const isAmeerikaEestis = theme === ThemeEnum.AMEERIKAEESTIS

  const isAlt = !isShipzee
  const isAlt2 = isNoriuLive || isAmeerikaEestis || isWhitelabel

  const className = [
    !isShipzee ? ThemeEnum.ALTERNATE : '',
    isPerkujav ? ThemeEnum.PERKUJAV : '',
    isTarpininke ? ThemeEnum.TARPININKE : '',
    isWhitelabel ? ThemeEnum.WHITELABEL : '',
    isNoriuLive ? ThemeEnum.NORIULIVE : '',
    isAmeerikaEestis ? ThemeEnum.AMEERIKAEESTIS : '',
  ]

  return {
    theme,
    className,
    // Layout
    isAlt,
    isAlt2,
    // Themes
    isTarpininke,
    isShipzee,
    isWhitelabel,
    isPerkuJavTheme: isPerkujav,
    isNoriuLive,
    isAmeerikaEestis,
  }
}
